import * as React from 'react'
import { splitEmployeeCount } from '../extra/formatters'
import { SEGMENT_TABLE_COLUMN_WIDTHS } from '../extra/tableColumnWidths'
import TableColgroup from './TableColgroup'
import TableEmptyMessage from './TableEmptyMessage'

/**
 * @param {{
 *   rows: { name: string; count: string }[]
 *   total: { name: string; count: string }
 * }} props
 */
const ConsolidatedCompanyTable = ({ rows, total }) => {
  const hasData = (rows ?? []).length > 0

  return (
    <div className="mb-8 px-12">
      <h3 className="text-base font-semibold mb-4 p-0">① 連結会社の状況</h3>
      {!hasData ? (
        <TableEmptyMessage />
      ) : (
        <table className="securities-report-indicators__table securities-report-indicators__table--segment">
          <TableColgroup widths={SEGMENT_TABLE_COLUMN_WIDTHS} />
          <thead>
            <tr>
              <th align="center">セグメントの名称</th>
              <th align="center">従業員数(名)</th>
              <th align="center">臨時従業員数(名)</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => {
              const count = splitEmployeeCount(row.count)
              return (
                <tr key={row.name}>
                  <td>{row.name}</td>
                  <td align="center">{count.main}</td>
                  <td align="center">{count.temp}</td>
                </tr>
              )
            })}
            {(() => {
              const totalCount = splitEmployeeCount(total.count)
              return (
                <tr className="total-row">
                  <th className="total-cell" align="center">
                    {total.name}
                  </th>
                  <th className="total-cell" align="center">
                    {totalCount.main}
                  </th>
                  <th className="total-cell" align="center">
                    {totalCount.temp}
                  </th>
                </tr>
              )
            })()}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default ConsolidatedCompanyTable
